// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"305":"6c405e73","325":"7c5325db","425":"4494c7da","453":"747f4116","642":"3f1caa41","996":"a19251d5"}[chunkId] + ".chunk.js";
};